export default "__VITE_ASSET__BBvoXu4I__"